module.exports = __webpack_public_path__ + "media/images/static/top/urban/首都圏MV-9e624604e7efa436c6d1f7f1ca690b0b.png";